<template>
  <div class="doomyogahome">
    <div
      v-if="draw_nav_layout == true"
      class="main-panel main-panel-customer-dy w-100"
      :style="{ 'background-image': 'url(' + background_img + ')' }"
    >
      <DoomYogaNavbar />
      <div class="content">
        <router-view :key="$route.fullPath" />
        <DoomYogaFooter v-if="draw_footer == true" />
      </div>
      <!-- <DoomYogaFooter /> -->
    </div>
    <router-view :key="$route.fullPath" v-else />
  </div>
</template>


<script>
import $ from "jquery";
import DoomYogaNavbar from "@/components/partials/navbar_doom_yoga";
import DoomYogaFooter from "@/components/partials/footer_doom_yoga";

export default {
  name: "DoOmYogaCustomerIndex",
  components: { DoomYogaNavbar, DoomYogaFooter },
  data() {
    return {
      loginuser: null,
      background_img: "none",
      draw_nav_layout: true,
      draw_footer: true,
    };
  },

  mounted() {
    // console.log("rrrrrr " + this.$route.name);
    // console.log("session ", localStorage.getItem("user"));
    this.setPageBackground();
    this.checkRoute();
    this.checkPlayerPage();
  },
  updated() {
    // console.log("in index updated ",this.$route.name);
    this.setPageBackground();
    this.checkRoute();
    this.checkPlayerPage();

    // alert("home updated");
    // console.log($(".nav-open"));
   if($(".navbar-collapse.collapse").hasClass("show")){
    $(".navbar-collapse.collapse").removeClass("show")
   }
  },
  methods: {
    setPageBackground() {
      if (this.$route.name == "DoOmYogaCustomerHome") {
        this.background_img = "none";
      } else if (this.$route.name == "DoOmYogaCustomerEventsCalendar") {
        this.background_img = require("@/assets/images/doom-yoga/mountain_background.png");
        // $("#app").css("background-image",'url('+require("@/assets/images/doom-yoga/mountain_background.png")+')')
      } else if (
        this.$route.name == "DoOmYogaCustomerProfileIndex" ||
        this.$route.name == "DoOmYogaCustomerEditProfile" ||
        this.$route.name == "DoOmYogaCustomerProfileSubscription"
      ) {
        this.background_img = require("@/assets/images/doom-yoga/profile-background.png");
      } else {
        this.background_img = "none";
      }
    },
    checkRoute() {
      if (
        this.$route.name == "DoOmYogaCustomerEventsBookSummary" ||
        this.$route.name == "DoOmYogaCustomerEventsBookAsGuest" ||
        this.$route.name == "DoOmYogaCustomerEventsBookPayment"
      ) {
        this.draw_nav_layout = false;
      } else {
        this.draw_nav_layout = true;
      }
    },
    checkPlayerPage() {
      if (
        this.$route.name == "DoOmYogaCustomerMeditationAudioPlaylist" ||
        this.$route.name == "DoOmYogaCustomerMusicSpotifylaylist" ||
        this.$route.name == "DoOmYogaCustomerMusicMP3Playlist"
      ) {
        this.draw_footer = false;
      } else {
        this.draw_footer = true;
      }
    },
  },
};
</script>
<style scoped::v-deep >
@import "../css/doom-yoga-fonts.css";
@import "../css/doom-yoga-buttons-styles.css";
@import "../css/doom-yoga-customer-styles.css";
@import "../css/doom-yoga-calendar-customer-styles.css";
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Index.vue